import { Routes } from '@angular/router';
import { authGuard } from '@guards/auth.guard';
import { hasPermissionsGuard } from '@guards/has-permissions.guard';
import { NoPenalPage } from './no-penal/no-penal.component';
import { NoInhabilitacionPage } from './no-inhabilitacion/no-inhabilitacion.component';
import { FederalPage } from './federal/federal.component';

let moduleName = 'antecedente';

export const antecedente: Routes = [
  {
    path: `${moduleName}/no-penal`,
    component: NoPenalPage,
    title: 'Antecedentes - No penales.',
    canActivate: [authGuard, hasPermissionsGuard(['antecedente_no_penal_access'])],
  },
  {
    path: `${moduleName}/no-inhabilitacion`,
    component: NoInhabilitacionPage,
    title: 'Constancias - No inhabilitación.',
    canActivate: [authGuard, hasPermissionsGuard(['antecedente_no_inhabilitacion_access'])],
  },
  {
    path: `${moduleName}/federal`,
    component: FederalPage,
    title: 'Antecedente Federal.',
    canActivate: [authGuard, hasPermissionsGuard(['antecedente_federal_access'])],
  },
];
